export function redirect_to_backend_admin(redirectUrl) {
  const domain = reloansysConfig.backendAdminAuthBaseUrl;
  const token = JSON.parse(localStorage.getItem("admin.usr")).access_token;
  const url = domain + "/auth/signin_from_token";
  const body = JSON.stringify({ token, redirect: redirectUrl });
  const options = {
    method: "POST",
    body,
    headers: {
      "Content-Type": "application/json",
    },
  };

  fetch(url, options);
  const xUrl = domain + redirectUrl;
  window.open(xUrl, "_blank");
}
